import { render, staticRenderFns } from "./DfmAdSmall.vue?vue&type=template&id=20ae0f8c"
import script from "./DfmAdSmall.vue?vue&type=script&lang=js"
export * from "./DfmAdSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports